/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Header_Original_DialogueInputs */



/**
* | output |
* | --- |
* | "ORIGINAL DIALOGUE" |
*
* @param {Ccsl_Export_Header_Original_DialogueInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_header_original_dialogue = /** @type {((inputs?: Ccsl_Export_Header_Original_DialogueInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Header_Original_DialogueInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("DIALOGUE ORIGINAL")
	if (locale === "de") return /** @type {LocalizedString} */ ("ORIGINALDIALOG")
	if (locale === "it") return /** @type {LocalizedString} */ ("DIALOGO ORIGINALE")
	if (locale === "ru") return /** @type {LocalizedString} */ ("ОРИГИНАЛЬНЫЙ ДИАЛОГ")
	if (locale === "es") return /** @type {LocalizedString} */ ("DIÁLOGO ORIGINAL")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("原始对话")
	if (locale === "ja") return /** @type {LocalizedString} */ ("オリジナルセリフ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मूल संवाद")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("DIÁLOGO ORIGINAL")
	return /** @type {LocalizedString} */ ("ORIGINAL DIALOGUE")
});